<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-row justify="center" class="pt-8" no-gutters>
        <v-col xl="8" lg="11" md="11" sm="11" cols="12">
          <v-row justify="center" class="mx-0">
            <v-col cols="12">
              <v-text-field class="mt-n4"
                v-model="user.password"
                label="Contraseña"
                hint="Requerido"
                :rules="[isRequired, minimum(6)]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                autocomplete="new-password"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field class="mt-n4"
                v-model="user.new_password"
                label="Repetir contraseña"
                hint="Requerido"
                :rules="[isRequired, stringsMatch(user.password, 'Las contraseñas no coinciden.')]"
                :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNewPassword ? 'text' : 'password'"
                @click:append="showNewPassword = !showNewPassword"
                autocomplete="new-password"
                persistent-hint
                solo>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end" class="mt-n3 pb-6 mx-0">
            <v-col xl="6" lg="6" md="6" sm="12" cols="12">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" :disabled="!valid" :dark="valid" @click="save">
                Guardar
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { isRequired, minimum, stringsMatch } from '@/shared/validations'

export default {
  name: 'PasswordForm',
  props: {
    user: {
      type: Object,
      default: function () {
        return {
          user_id: null,
          password: null,
          new_password: null
        }
      }
    }
  },
  data () {
    return {
      valid: true,
      showPassword: false,
      showNewPassword: false
    }
  },
  computed: {
    ...mapState('shared', ['loading', 'error'])
  },
  methods: {
    isRequired,
    minimum,
    stringsMatch,
    ...mapActions('user', ['updateUser']),
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      await this.updateUser(this.user)
      if (!this.error) {
        this.$refs.form.reset()
      }

      this.$emit('save')
    }
  }
}
</script>
